<script lang="ts">
  import { onMount } from 'svelte';
  import type { SquareLogoInSubnavProps } from './types';

  const PUBLIC_WEB_NAV_READY = 'public-web-nav-ready';

  type $$Props = SquareLogoInSubnavProps;

  let logoLockup: Node;
  function extractLogo() {
    const logoElement =
      document.querySelector('#public-web-nav svg.LogoLockup') ||
      document.querySelector('#public-web-nav svg.LogoJewel');
    if (logoElement) {
      logoLockup = logoElement.cloneNode(true);
    }
  }

  function addSquareLogoToSubnav() {
    let subNavLeftSlot = document.querySelector('#public-web-nav .CtaSubnavDesktopNav .left-slot');
    if (!subNavLeftSlot) {
      subNavLeftSlot = document.querySelector('#public-web-nav .CtaSubnavMobileNav .HeaderMenu .truncate-wrapper');
    }

    if (subNavLeftSlot) {
      // Clear existing text
      subNavLeftSlot.innerHTML = '';

      // Add logo to the left slot
      subNavLeftSlot.appendChild(logoLockup);
    }
  }

  onMount(() => {
    const publicWebNavWrapper = document.querySelector('#public-web-nav') as HTMLElement | null;

    if (publicWebNavWrapper) {
      if (publicWebNavWrapper.dataset?.ready) {
        extractLogo();
        addSquareLogoToSubnav();
      } else {
        // If onMount for public web nav fires much later, we rely on the event
        publicWebNavWrapper.addEventListener(PUBLIC_WEB_NAV_READY, () => {
          extractLogo();
          addSquareLogoToSubnav();
        });
      }

      // Add mutation observer for breakpoint changes
      const publicWebNav =
        publicWebNavWrapper.querySelector('.PublicWebNav') || publicWebNavWrapper.querySelector('.PublicWebNavV2');
      if (publicWebNav) {
        const observer = new MutationObserver((mutationList) => {
          for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-nav-device-type') {
              addSquareLogoToSubnav();
            }
          }
        });
        observer.observe(publicWebNav, { attributes: true });
      }
    }
  });
</script>

<style lang="scss">
  :global {
    #public-web-nav .CtaSubnavDesktopNav .left-slot {
      display: flex;
      align-items: center;
    }
  }
</style>
